// extracted by mini-css-extract-plugin
module.exports = {"heading_wrapper":"heading_heading_wrapper__De3HD","heading":"heading_heading__7RJoj","short_description":"heading_short_description__rdH6O"};